<template>
  <div :class="['room-rate', { 'is-selected': is_selected }]" @click="selected_rate_by_radio_value()">
    <b-row>
      <b-col lg="7">
        <div class="room-rate__header">
          <span class="room-rate__header-title">
            Soluzione {{ rate_index }}
          </span>
          <span v-if="rate_availability" :class="'room-rate__header-available ' + rate_availability.class">
            {{ rate_availability.text }}
          </span>
        </div>

        <div class="room-rate__info">
          <rate-promotions
            :promos="room_rate_data.rate.promotions"
            :show="'value_adds'"
          />
          <rate-info
            :rate="room_rate_data.rate"
          />
        </div>
      </b-col>
      <b-col lg="5">
        <rate-promotions
          :promos="room_rate_data.rate.promotions"
        />
        <div class="room-rate__pricing">
          <rate-amount
            :prices="room_rate_data.rate.pricing"
            @update:amount_points="handle_amount_points"
          />
        </div>
        <div class="room-rate__fees" v-if="Object.keys(fees).length">
          <vb-icon :name="'info'" :color="sass('gray-600')" :size="12" class="mr-1" />
          <span :id="'popover-fees-' + room_rate_data.rate.id">
            Da pagare in struttura: <strong class="semibold">€ {{ fees.total }}</strong>
          </span>
          <b-popover
            :target="'popover-fees-' + room_rate_data.rate.id"
            triggers="hover"
            placement="top"
          >
            <span class="d-block mb-1">Costi non inclusi e da pagare in struttura:</span>
            <ul class="m-0 p-0">
              <li class="d-flex justify-content-between" v-for="(item, key) in fees.items" :key="_uid+'_fee_'+key">
                <span>{{ item.label }}:</span>
                <span>€ {{ item.price }}</span>
              </li>
            </ul>
          </b-popover>
        </div>
      </b-col>
      <b-col lg="9">
        <div class="room-rate__beds">
          <div
            class="room-rate__beds-item"
            v-for="bed_type in room_rate_data.rate.bed_groups"
            :key="bed_type.id"
            :set_radio_value="value = get_radio_value(bed_type)"
          >
            <b-form-radio
              class="vb-radio vb-radio--light d-flex"
              v-model="radio_value"
              :name="value"
              :value="value"
              @click.stop
              @change="selected_rate(bed_type)"
            >
            <span v-b-popover.hover.top="'La struttura non garantisce la disponibilità del letto selezionato'">
              {{ bed_type.description }}
            </span>
            </b-form-radio>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="room-rate__btn">
          <vb-button
            :class="{ 'active': is_selected }"
            :vb_options="{
              text: 'Scegli',
              variant: 'info',
              size: 'sm',
            }"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { sum, number, round } from 'mathjs'
import { get_fees } from "@liveeps/resources"
import RateInfo from "@liveeps/components/atoms/rate-info"
import RateAmount from "@liveeps/components/blocks/rate-amount"
import RatePromotions from "@liveeps/components/blocks/rate-promotions"

export default {
  name: 'room-rate',

  components: {
    'rate-info': RateInfo,
    'rate-amount': RateAmount,
    'rate-promotions': RatePromotions,
  },

  props: {
    room_rate_data: Object,
    is_selected: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      radio_value: null,
      amount_points: null
    }
  },

  provide() {
    return {
      prices: () => this.room_rate_data.rate.pricing // injection per rate-deal
    }
  },

  computed: {

    // Struttura prezzi fees
    fees() {
      const { pricing } = this.room_rate_data.rate
      if(!pricing.fees) return {}
      const { fees } = pricing

      let n_fees = Object.entries(fees).map(([key, value]) => ({
        ...get_fees(key),
        price: number(value)
      }))

      return {
        ...(fees ? {
          items: n_fees,
          total: round(Object.values(n_fees).reduce((smy, val) => sum(smy, val.price), 0), 2),
        } : {})
      }
    },

    // Ritorna classe e copy del numero di camere disponibili
    rate_availability() {
      const rate = this.room_rate_data.rate,
            count = rate && rate.available_rooms

      if(count < 5)
        return {
          class: 'last',
          text: count + (count === 1 ? ' camera disponibile' : ' camere disponibili')
        }
      return null
    },

    // Ritorna l'indice della soluzione corrente
    rate_index() {
      return Object.values(this.room_rate_data.room.rates).findIndex(obj => obj.id === this.room_rate_data.rate.id) + 1
    }
  },

  created() {
  },

  mounted() {
    this.radio_value = this.get_radio_value(this.room_rate_data.rate.bed_groups[0])
  },

  methods: {

    // Ritorna id del rate composto da room, rate e bed_type
    get_radio_value(bed_type) {
      return `${this.room_rate_data.room.id}-${this.room_rate_data.rate.id}-${bed_type.id}`
    },

    // Aggiorna amount_points con la struttura amount_points { points: X, currency: Y }
    handle_amount_points(val) {
      this.amount_points = val
    },

    // Seleziona la camera in base al radio_value
    selected_rate_by_radio_value() {
      const bed_type = this.room_rate_data.rate.bed_groups.find(
        bed => this.get_radio_value(bed) === this.radio_value
      )
      if (bed_type) this.selected_rate(bed_type)
    },

    // Emette la camera selezionata
    selected_rate(bed_type) {
      const radio_value = this.get_radio_value(bed_type),
            points = this.amount_points

      this.$nextTick(() => {
        this.radio_value = radio_value
      })

      this.$emit('selected-rate', {
        room: this.room_rate_data.room,
        rate: this.room_rate_data.rate,
        radio_value: radio_value,
        bed_type: bed_type,
        amount_points: points
      })
    },
  },
}
</script>

<style lang="scss" scoped>

  .room-rate {
    background-color: $white;
    padding: $grid-gutter-width / 2;
    border-radius: $border-radius-lg * 2;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background-color: $selected;
      border-color: $info;

      @include media-breakpoint-up(lg){
        border-color: $gray-300;
        box-shadow: 0 0 0 1px rgba(0,0,0, .02),0 5px 15px 0 rgba(0,0,0, .10)
      }
    }

    &__header {
      display: flex;
      align-items: center;
      margin-bottom: $grid-gutter-width / 3;

      &-title{
        font-weight: $vb-font-weight-semibold;
        color: $gray-600;
        background-color: $gray-200;
        padding: 3px 5px;
        border-radius: $border-radius-lg;
        line-height: normal;
      }

      &-available {
        font-size: $font-size-sm;
        margin-left: $grid-gutter-width / 3;

        &.last {
          color: $secondary;
        }
      }
    }

    &__info {
      margin-bottom: $grid-gutter-width / 2;

      @include media-breakpoint-up(lg){
        margin-bottom: 0;
      }
    }

    &__fees {
      display: flex;
      align-items: center;
      font-size: $font-size-sm;
      margin-top: $grid-gutter-width / 6;
      color: $gray-800;
      cursor: default;
      justify-content: center;

      @include media-breakpoint-up(lg){
        justify-content: flex-end;
      }
    }

    &__beds {
      font-size: $font-size-md;
      margin-top: $grid-gutter-width / 2;

      @include media-breakpoint-up(md){
        display: flex;
        align-items: center;
        margin-top: $grid-gutter-width / 3;
      }

      &-item {
        margin-right: $grid-gutter-width / 2;
        margin-top: $grid-gutter-width / 6;

        @include media-breakpoint-up(md){
          margin-top: 0;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      ::v-deep {

        .custom-control {

          &-label {
            display: flex;
            align-items: center;
            cursor: pointer;

            span {
              position: relative;
              top: 2px;
            }

            &:after {
              top: .56rem;
            }
          }
        }
      }
    }

    &__pricing {
      display: flex;
      flex-flow: column;
      align-items: center;
      text-align: center;

      @include media-breakpoint-up(lg){
        align-items: flex-end;
      }
    }

    &__btn {
      display: flex;
      justify-content: center;
      margin-top: $grid-gutter-20;

      @include media-breakpoint-up(lg){
        margin-top: $grid-gutter-width / 4;
        justify-content: end;
      }

      .vb-btn {
        width: $grid-gutter-width * 3;
      }

      .active {
        color: var(--primary) !important;
      }
    }
  }

</style>